import Http from '@/utils/http/index';

export default {

  /**
   * 换汇列表查询
   * @param {*} params
   * @returns
   */
  getExchangeList(params) {
    return Http.get('/merchantExchange/list', { params });
  },

  /**
   * 换汇列表下载
   * @param {*} params
   * @returns
   */
  async downLoadExchangeList(params) {
    return Http.get('/merchantExchange/download', { params });
  },

  /**
   * 换汇汇率查询
   * @param {*} data
   * @returns
   */
  getExchangeRate(data) {
    return Http.post('/merchantExchange/query', data);
  },

  /**
   * 锁汇
   * @param {*} data
   * @returns
   */
  getLockExchangeRate(data) {
    return Http.post('/merchantExchange/rate', data);
  },

  /**
   * 换汇交割
   * @param {*} id
   * @returns
   */
  addExchange(id) {
    return Http.post('/merchantExchange/add', { id });
  },
};
